module.exports = __webpack_public_path__ + "static/media/avatar.80e10f93.svg";